import JobFormModal from "./JobFormModal";

export default function JobCreate(props) {
    return (
        <JobFormModal
            mode="create"
            isModalVisible={props.isModalVisible}
            handleShowB={props.handleShowB}
        />
    );
}
